<route-meta>
{
  "requiresAuth": true
}
</route-meta>

<template>
  <div class="logs">
    <div
      v-for="(log, logindex) in logs"
      :key="`log-${logindex}`"
    >
      <h2>{{ log.type }}</h2>
      <pre v-html="log.content"></pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'logs',
  data() {
    return {
      logs: [],
    };
  },
  created() {
    this.$http.get(`${process.env.VUE_APP_API}/logs?type=ssl`).then(data => {
      this.logs.push(data.data);
    });
    this.$http.get(`${process.env.VUE_APP_API}/logs?type=deploy`).then(data => {
      this.logs.push(data.data);
    });
  },
};
</script>

<style lang="scss" scoped>
pre {
  height: 400px;
  overflow-y: auto;
  font-size: 0.8em;
}
</style>
